import React from 'react';
import { connect } from 'react-redux';
import { getMessages } from '../../actions/alert_actions';
import { bindActionCreators } from 'redux';

class RecentMessages extends React.Component {

  componentDidMount() {
    this.props.getMessages();
  }

  renderList() {
    //render list of previously sent messages
    return this.props.list.map((message,i) => {
      return (
        <tr key={i.toString()}>
          <td>{message.dateSent.substring(0,10)}</td>
          <td>{message.message}</td>
          <td>{message.location}</td>
        </tr>
      );
    });
  }

  render() {
    return (
      <div className={this.props.className}>
        <div className="messages-table">
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Message</th>
                <th>Location</th>
              </tr>
            </thead>
            <tbody>
              {this.renderList()}
            </tbody>
          </table>
        </div>
      </div>

    );
  }
}

function mapStateToProps(state) {
  return {
    list: state.messages.messages
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getMessages
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(RecentMessages);



// WEBPACK FOOTER //
// ./src/components/alert/recent-messages.js